<template>
    <div class="sale-list-wrapper">
        <div class="sale-tit-wrap">
            <span class="sale-tit active">销售数据</span>
        </div>
            <div class="sale-list">
                <div class="list-tit">账户概况</div>
                <div class="total-wrap">
                    <div class="total-item">
                        <div>本月待结算金额（元）</div>
                        <div>{{(totalInfo.settlementMoney || 0).toFixed(2)}}</div>
                    </div>
                    <div class="total-item">
                        <div>本月订单量（个）</div>
                        <div>{{totalInfo.orderNum || 0}}</div>
                    </div>
                    <div class="total-item">
                        <div>上月待结算金额（元）</div>
                        <div>{{(totalInfo.lastMonthNotSettlementMoney || 0).toFixed(2)}}</div>
                    </div>
                    <div class="total-item">
                        <div>上月订单量</div>
                        <div>{{totalInfo.lastMonthOrderNum || 0}}</div>
                    </div>
                    <div class="total-item">
                        <div>上月已结算金额（元）</div>
                        <div>{{(totalInfo.lastMonthSettlementMoney || 0).toFixed(2)}}</div>
                    </div>
                    <div class="total-item">
                        <div>累计收入（元）</div>
                        <div>{{(totalInfo.totalSettlementMoney || 0).toFixed(2)}}</div>
                    </div>
                </div>
            </div>
            <div class="sale-list">
                <div class="list-tit">
                    详细数据
                    <el-input class="tit-input" @keyup.enter.native="getList" placeholder="请输入素材名称" v-model="queryInfo.materialName">
                        <i class="el-icon-search" @click="getList" slot="append"></i>
                    </el-input>
                </div>
                <EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
                <div v-else class="list-wrap">
                    <div class="table-tit">
                        <div class="table-th">
                            序号
                        </div>
                        <div class="table-th">
                            下单时间
                        </div>
                        <div class="table-th">
                            商品名称
                        </div>
                        <div class="table-th">
                            订单类型
                        </div>
                        <div class="table-th">
                            授权类型
                        </div>
                        <div class="table-th">
                            作者
                        </div>
                        <div class="table-th">
                            售价（元）
                        </div>
                        <div class="table-th">
                            结算金额（元）
                        </div>
                    </div>
                    <div class="table-row" v-for="(item,index) in list" :key="item.orderId">
                        <div class="table-th table-td">
                            <span>{{index + 1}}</span>
                        </div>
                        <div class="table-th table-td" :title="item.orderTime">
                            <span>{{item.orderTime}}</span>
                        </div>
                        <div class="table-th table-td" :title="item.goodsName">
                            <span>{{item.goodsName}}</span>
                        </div>
                        <div class="table-th table-td" :title="item.orderType">
                            <span>{{item.orderType | formatType}}</span>
                        </div>
                        <div class="table-th table-td" :title="item.empowerType">
                            <span>{{item.empowerType | formatEmpowerType}}</span>
                        </div>
                        <div class="table-th table-td" :title="item.author">
                            <span>{{item.author}}</span>
                        </div>
                        <div class="table-th table-td" :title="item.price">
                            <span>{{(item.salePrice || 0).toFixed(2)}}</span>
                        </div>
                        <div class="table-th table-td" :title="item.settlementMoney">
                            <span>{{(item.settlementMoney || 0).toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="loading" v-show="loading">
                <i class="el-icon-loading"></i>
            </div>
            <!-- 分页 -->
            <div class="sale-list__pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :current-page="pageNum"
                    :total="total"
                    @current-change="handlePageChange">
                </el-pagination>
            </div>
        </div>
</template>
<script>
import { getSaleTotal, getSaleList } from '@/api/sale';
import EmptyPage from '@/components/EmptyPage';
const  typeOptions= [
    {label: '素材订单', value: 0},
    {label: '解决方案', value: 1},
    {label: '服务案例', value: 2},
    {label: '源码订单', value: 3},
]
const  empowerTypeOptions= [
    {label: '个人授权', value: 0},
    {label: '商用授权', value: 1},
    {label: '商用plus授权', value: 2},
]
export default {
    data(){
        return{
            totalInfo:{},
            loading: true,
            total: 0,
            pageSize: 40,
            pageNum: 1,
            list: [],
            queryInfo:{}
        }
    },
    components: {
        EmptyPage
    },
    filters:{
        formatType(value) {
            return (typeOptions.find(item => item.value === value) || {label: '--'}).label
        },
        formatEmpowerType(value) {
            return (empowerTypeOptions.find(item => item.value === value) || {label: '--'}).label
        }
    },
    created(){

    },
    mounted(){
        this.getTotal()
        this.initPageParams()
        this.getList()
    },
    methods:{
        initPageParams() {
            this.pageNum = 1;
            this.pageSize = 15;
            this.total = 0;
        },
        async getTotal() {
            try {
                const {data} = await getSaleTotal()
                this.totalInfo = data || {}
            } catch (error) {
                console.log('error: ', error);
            }
        },
        handlePageChange(pageNum) {
            this.pageNum = pageNum;
            this.getList();
        },
        async getList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    ...this.queryInfo
                };
                const { code, data, total } = await getSaleList(params);
                if (code === 0) {
                    this.list = data || [];
                    this.total = total;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .sale-list {
        &-item {
            display: inline-block;
            width: 300px;
            margin-right: 25px;
            margin-top: 0;

            &:nth-child(5n + 5) {
                margin-right: 0;
            }

            &:nth-child(n + 6) {
                margin-top: 20px;
            }
        }
        &__pagination {
            margin-top: 45px;
            padding-bottom: 45px;
            text-align: center;
        }
    }
    .sale-tit-wrap {
        margin-bottom: 20px;
        .sale-tit {
            height: 28px;
            padding: 0 12px;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 85px;
            @include font(rgba(113, 119, 152, 1), 16px, 400);
            cursor: pointer;

            &:not(:first-child) {
                margin-left: 18px;
            }

            &:hover {
                @include font(rgba(47, 84, 235, 1), 16px, 400);
            }

            &.active {
                background-color: rgba(47, 84, 235, 1);
                color: #fff;

                &:hover {
                    color: #fff;
                }
            }
        }
    }

    .loading {
        margin: 20px 0;
        text-align: center;
        font-size: 32px;    
    }
    .sale-list {
        margin-bottom: 16px;
        background: #fff;
        .list-tit {
            display: flex;
            height: 50px;
            padding: 0 27px;
            line-height: 50px;
            background: #667381;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            align-items: center;
            .tit-input {
                width: 215px;
                margin-left: 30px;
                height: 30px;
                /deep/ input {
                    border-radius: 50px;
                    height: 30px;
                    padding-right: 40px;
                }
                /deep/ .el-icon-search {
                    cursor: pointer;
                }
                /deep/ .el-input-group__append {
                    height: 30px;
                    padding: 0 10px;
                    position: relative;
                    right: 40px;
                    background: rgba(0,0,0,0);
                    border: 0;
                }
            }
        }
        .total-wrap {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 133px;
            border: 1px solid #E0E4F7;
            border-top: 0;
            .total-item {
                height: 100%;
                flex-direction: column;
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                &>div:nth-child(1) {
                    margin-bottom: 21px;
                    color: #81888D;
                    font-size: 14px;
                    font-weight: 400;
                }
                &>div:nth-child(2) {
                    color: #EB793C;
                    font-size: 30px;
                    font-weight: 600;
                }
                &:nth-child(3),&:nth-child(4),&:nth-child(5) {
                    &>div:nth-child(2) {
                        color: #949DA7;
                    }
                }
            }
        }
    }
    // .list-wrap {
    //     border: 1px solid #E0E4F7;
    //     border-top: 0;
    // }
    .table-tit  {
        display: flex;
        .table-th {
            height: 50px;
            background: #949DA7;
            border-right: 1px solid #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 14px;
            font-weight: 600;
            padding: 0 10px;
            &:nth-last-child(1) {
                border: 0;
            }
        }
    }
    .table-row {
        display: flex;
        overflow: hidden;
        .table-td {
            overflow: hidden;
            border-right: 1px solid #fff;
            padding: 0 10px;
            &:nth-last-child(1) {
                border: 0;
            }
            span {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                color: #333333;
                font-size: 14px;
            }
        }
    }
    .table-tit, .table-row {
        .table-th {
            height: 40px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            &:nth-child(1) {
                width: 64px;
                flex: none;
            }
            &:nth-child(2) {
                width: 243px;
                flex: none;
            }
            &:nth-child(3) {
                flex: 1.5;
            }
        }
    }
    

    // 小屏
    @include mq($small) {
        .sale-list {

            &-item {
                width: 225px;
                margin-right: 15px;
                margin-top: 0;

                &:nth-child(5n + 5) {
                    margin-right: 0;
                }

                &:nth-child(n + 6) {
                    margin-top: 15px;
                }
            }
            &__pagination {
                margin-top: 30px;
                text-align: center;
            }
        }
    }
</style>